// import { GetAppIcon } from '@material-ui/icons';
import './Download.css'
import GetAppIcon from '@material-ui/icons/GetApp';
import logo from '../res/img/AMO_Logo.png';
import axios from 'axios';
import { Link } from 'react-router-dom';

function getMobileOperatingSystem() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    console.log("userAgent::",userAgent)
    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
        return "Windows Phone";
    }

    if (/android/i.test(userAgent)) {
        return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return "iOS";
    }

    return "Other";
}
function downloadAndroid(){
    window.location.href = 'dl/and/amo.apk'
}
function getDownloadLinkIOS(){
    axios.get(`/get-update-link/3`)
        .then(res => {
            console.log("response::", res)
            let response = res.data
            
            if(response.errors){
                alert(response.errors[0].Message)
                return
            }

            window.location.href = response.data.Link
        })

}
function Download(){

    const manuals = [
        {link:"/res/manual/register-v2.pdf", title:"ขั้นตอนการดาวน์โหลดและลงทะเบียนแอปพลิเคชั่น AMO"},
        {link:"/res/manual/mobile-manual.pdf", title:"คู่มือการใช้งานแอปพลิเคชั่น AMO สำหรับ มือถือ"},
        {link:"/res/manual/center-manual.pdf", title:"คู่มือการใช้งานแอปพลิเคชั่น AMO สำหรับ ศูนย์ควบคุม"},
        {link:"/res/manual/faq-v2.pdf", title:"ปัญหาการใช้งานที่พบบ่อย"}
    ]
    console.log("getMobileOperatingSystem::",getMobileOperatingSystem())
    let agent = getMobileOperatingSystem()
    let showAndroid = true
    let showIOS = true
    if(agent === "Android"){
        showIOS = false
    } else if (agent === "iOS"){
        showAndroid = false
    }
    return(
        <div class="container">
            <div>
                <div class="logo">
                    <img class="img-fluid" src={logo}/>
                </div>
                <div>
                    <h2 class="amo-name">Advanced Military Operations</h2>
                </div>
                <div class="input">
                    {
                        showAndroid ? <input class="download-button" type="button" value="ดาวน์โหลดแอปพลิเคชัน (Android)" onClick={downloadAndroid}/> : ""
                    }
                    {
                        
                        showIOS ? <input class="download-button" type="button" value="ดาวน์โหลดแอปพลิเคชัน (iOS)" onClick={getDownloadLinkIOS}/> : ""
                    }
                </div>

                <hr class="hr-download"/>
                <div>
                    <ul class="manual">
                        {
                            manuals.map((el) => {
                                return (
                                    <li>
                                        <GetAppIcon style={{ color: "white",  verticalAlign: "middle"}}/>
                                        <a href={el.link}>{el.title}</a>
                                    </li>
                                )
                            })
                        }
                    </ul>
                </div>
                <div>
                    {/* <Link to="/cookies-policy" style={{color: "white", margin: "0 5px", textDecoration: "none"}}>CookiePolicy</Link> */}
                    <Link to="/privacy-policy" style={{color: "white", margin: "0 5px", textDecoration: "none"}}>PrivacyPolicy</Link>
                    <Link to="/contact-us" style={{color: "white", margin: "0 5px", textDecoration: "none"}}>Contact Us</Link>
                </div>
            </div>
        </div>
    )
}



export default Download;